// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import cookie       from 'js-cookie';

const fragments = {
  CLOSE: '[data-fragment="InformationRectangle.close"]',
};

const COOKIE_NAME = 'informationRectanglesSeen';

export default class InformationRectangle extends WebComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  didMount() {
    this.on('click', fragments.CLOSE, this.handleClick);

    /* Creating of cookies if doesn't exist */
    if ( !cookie.get(COOKIE_NAME) ) cookie.set(COOKIE_NAME, '');

    /* Check for information if they have been seen */
    this.loadInformationRectangles();
  }

  loadInformationRectangles() {
    const seenElements = cookie.get(COOKIE_NAME).split('|');

    for ( let i = 0; i < seenElements.length; i++ ) {
      if ( !isNaN(seenElements[ i ]) ) seenElements[ i ] = parseInt(seenElements[ i ], 10);
    }

    if ( !seenElements.includes(this.props.rectangleId) ) {
      this.element.classList.add('visible');
      document.body.scrollTop = 0;
    }
  }

  handleClick() {
    const seenElements = cookie.get(COOKIE_NAME).split('|');

    if ( !seenElements.includes(this.props.rectangleId) ) {
      cookie.set(COOKIE_NAME, (cookie.get(COOKIE_NAME) + this.props.rectangleId + '|'), { expires: 365.2425 * 5 });
      this.element.classList.remove('visible');
    }
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/InformationRectangle.js